module.exports = __webpack_public_path__ + "static/media/fh_vn.a3f9e101.png";